// これはVueではなくPureJSです。
import PARequest  from  '@/store/modules/Requests/Parts/PARequest'

import RegistrationStore  from '@/store/modules/Requests/Registration'
import AuthRequestStore   from '@/store/modules/Requests/Auth'
import UserStore          from '@/store/modules/Requests/User'

export default {
  namespaced  : true,

  modules     : {
    'registration'  : RegistrationStore,
    'auth'          : AuthRequestStore,
    'user'          : UserStore,
  },

  state       : {
    requestObject   : null,
    baseURL         : process.env.VUE_APP_PA_BASE_URL,

    paths           : {
      webApi  : {
        home  : '/web-api/v1/home'
      }
    },
  },

  mutations   : {
    initializeRequestObject(state, payload){
      state.requestObject = payload;
    }
  },

  actions     : {
    async apiRequest(context, payload){
      if(context.state.requestObject === null){
        context.dispatch('initializeRequest', null);
      }

      let result = null;

      try{
        result = await context.state.requestObject.apiRequest(payload);
      }catch(err){
        result = err.response;
      }

      if(
        (context.rootState.authentication.isAuthed === true) &&
        (result.status === 401)
      ){
        let tryHomeResult = null;
        try{
          tryHomeResult = await context.state.requestObject.apiRequest({
            method      : 'get',
            requestPath : context.state.paths.webApi.home,
          });
        }catch(err){
          tryHomeResult = err.response;
        }

        if(tryHomeResult.status === 200){
          await context.dispatch('authentication/setAuth', tryHomeResult.data, {root:true});

          // 取得したAuthorizeデータをもとにaxiosを再定義します。
          context.dispatch('initializeRequest', null);

          // その後同じリクエストもう一度投げてみます。
          try{
            result = await context.state.requestObject.apiRequest(payload);
          }catch(err){
            result = err.response;
          }
        }
      }

      return result;
    },

    initializeRequest(context){
      let parameters = {
        baseURL : context.state.baseURL
      };

      if(context.rootState.authentication.tokenType !== null){
        parameters.tokenType = context.rootState.authentication.tokenType;
      }

      switch(context.rootState.authentication.method){
        case 'api':
          if(context.rootState.authentication.accessToken !== null){
            parameters.accessToken = context.rootState.authentication.accessToken;
          }

          if(context.rootState.authentication.expiresIn !== null){
            parameters.expiresIn = context.rootState.authentication.expiresIn;
          }

          if(context.rootState.authentication.refreshToken !== null){
            parameters.refreshToken = context.rootState.authentication.refreshToken;
          }
        break;

        case 'web':
          if(context.rootState.authentication.csrfToken !== null){
            parameters.csrfToken = context.rootState.authentication.csrfToken;
          }
        break;
      }

      context.commit('initializeRequestObject', (new PARequest(parameters)));
    }
  }
}